import { Node } from "@xyflow/react";
import { DefaultNodeData, NodeData, TextNodeData, ZapNodeData } from "../types";

export function isDefaultNode(
  node: Node<NodeData>,
): node is Node<DefaultNodeData> {
  return node.type === "default";
}

export function isZapNode(node: Node<NodeData>): node is Node<ZapNodeData> {
  return node.type === "zap";
}

export function isTextNode(node: Node<NodeData>): node is Node<TextNodeData> {
  return node.type === "text";
}
